import { render, staticRenderFns } from "./Book1.vue?vue&type=template&id=c58e4ba8&scoped=true"
import script from "./Book1.vue?vue&type=script&lang=js"
export * from "./Book1.vue?vue&type=script&lang=js"
import style0 from "./Book1.vue?vue&type=style&index=0&id=c58e4ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58e4ba8",
  null
  
)

export default component.exports